











import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { StepKeys } from '../../variables/ACF_Key'
import Buttons from '../../components/Buttons.vue'
import Title from '../../components/Title.vue'
import Wizard from '../Wizard.vue'
import Loader from '../../components/Loader.vue'
@Component({
  components: {
    Buttons,
    Title,
    Wizard,
    Loader
  },
  computed: {
    ...mapState({
      responseACF: 'acfApi'
    })
  }
})
export default class EtapeFinal extends Vue {
    // Datas de la vue :
    public ready = false
    public image !: string
    // Data a transmettre au titre :
    public titleMain !: string
    public subTitle !: string
    // Datas a transmettre au bouton :
    public btn1 !: string
    public btn2 !: string
    public btn3 !: string
    public btn4 !: string

    //* ************ <!>IMPORTANT<!> -> Object pour enregistrer le JSON récupéré par AXIOS
    public responseACF!: Record<string, string>

    sortACFForThisView (): void{
      // Appel la class permettant de lire le trie du JSON (API WP)
      const thumbInfo = new StepKeys(this.responseACF)
      if (thumbInfo) {
        // Ajouter la clef ACF des items de la vue
        /***
         * INFO si dessous à modifier celon le projet :
         */
        this.btn1 = thumbInfo.getValue('thank_1')
        this.btn2 = thumbInfo.getValue('thank_2')
        this.btn3 = ''
        this.btn4 = ''
        /***
         * Titre de la vue :
         */
        this.titleMain = thumbInfo.getSimpleValue('thank_title')
        /***
         * Sous titre de la vue :
         */
        this.subTitle = thumbInfo.getSimpleValue('thank_title_sub')
        /**
         * Image de la vue
         */
        this.ready = true
      }
    }

    /***
     * VUE STATE =>
     */
    mounted (): void {
      this.$store.dispatch('LoadAllACF').then((data) => {
        if (data != null) {
          this.sortACFForThisView()
        }
      })
    }
}
